import React from 'react';
import PropTypes from 'prop-types';
import AskNikeAISearchResult from '../AskNikeAISearchResult';
import { SectionWrapper } from './styles';

/**
 * Nike AI Search Section
 * Lazy-loaded component for variant-B Nike AI integration
 * Uses fixed positioning to prevent jumping when search results change
 */
const NikeAISearchSection = ({ searchQuery, onAskNikeAIClick }) => {
  return (
    <SectionWrapper>
      {/* TG-8222: Converted to button element for proper keyboard activation */}
      {/* Button elements automatically handle Enter/Space key events */}
      <AskNikeAISearchResult onClick={onAskNikeAIClick} searchQuery={searchQuery} />
    </SectionWrapper>
  );
};

NikeAISearchSection.propTypes = {
  onAskNikeAIClick: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
};

NikeAISearchSection.defaultProps = {
  searchQuery: '',
};

export default NikeAISearchSection;
